/**
 * In case an explicit height or width has been set for a given icon, then
 * default icon dimensions should NOT be used. Therefore this utility ensures
 * that the default height is set to undefined in case an explicit height or
 * width prop has been set.
 */
function getDefaultHeight(props, fallback) {
  return props.height ?? props.width !== undefined ? undefined : fallback;
}

export { getDefaultHeight };
//# sourceMappingURL=get-default-height.js.map
